// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ToolView } from './ToolView';
export class VerticalLineToolView extends ToolView {
    IsSelectCheck(x, y) {
        const pX = this.screenPoints[0][0];
        const TOOL_DX_HALF = ToolView.TOOL_DX / 2;
        const xLeft = pX - TOOL_DX_HALF;
        const xRight = pX + TOOL_DX_HALF;
        return x >= xLeft && x <= xRight;
    }
    Draw(gr, ww, param) {
        // Ловим ошибки
        /*
    if (screenPoints[0][0] >= ProMath.infinity || screenPoints[0][1] >= ProMath.infinity || screenPoints[0][0] <= ProMath.infinityMinus || screenPoints[0][1] <= ProMath.infinityMinus)
        return;
    */
        const pen = this.dataCacheTool.Pen;
        const x = this.screenPoints[0][0];
        const CR = ww.ClientRectangle;
        const CRY = CR.Y;
        gr.DrawLine(pen, x, CRY, x, CRY + CR.Height);
        super.Draw(gr, ww, param);
    }
    DrawSelectedPoint(gr, ww, x, y) { }
    DrawSelectedLine(gr, ww, x1, y1, x2, y2) {
        const CR = ww.ClientRectangle;
        const CRY = CR.Y;
        super.DrawSelectedLine(gr, ww, x1, CRY, x2, CRY + CR.Height);
    }
}
